import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import EnlaceConComunicaciones from "./sections/EnlaceConComunicaciones";
import PreguntasDeAspirantes from "./sections/PreguntasDeAspirantes";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <EnlaceConComunicaciones />
      <PreguntasDeAspirantes />
      <Footer />
    </div>;
}